import { useEffect, useState } from "react";
import Hero from "@/components/home/Hero";
import PanelShowcase from "@/components/home/PanelShowcase";
import HowItWorks from "@/components/home/HowItWorks";
import PaymentsFeature from "@/components/home/PaymentsFeature";
import ShippingFeature from "@/components/home/ShippingFeature";
import Benefits from "@/components/home/Benefits";
import CategoriesGrid from "@/components/home/CategoriesGrid";
import PricingHighlight from "@/components/home/PricingHighlight";
import Faq from "@/components/home/Faq";
import CtaFinal from "@/components/home/CtaFinal";
import { fetchCategories } from "@/lib/api";
import { useHashScroll } from "@/lib/useHashScroll";

/**
 * Landing pública. Su único objetivo es que el visitante cree su tienda.
 * No muestra productos ni tiendas de los merchants — el catálogo público
 * solo vive en la página de cada tienda (/:storeSlug).
 */
export default function HomePage() {
    const [categories, setCategories] = useState([]);
    useHashScroll();

    useEffect(() => {
        fetchCategories().then(setCategories).catch(() => {});
    }, []);

    return (
        <div data-testid="home-page">
            <Hero />
            <PanelShowcase />
            <HowItWorks />
            <PaymentsFeature />
            <ShippingFeature />
            <Benefits />
            <CategoriesGrid categories={categories} />
            <PricingHighlight />
            <Faq />
            <CtaFinal />
        </div>
    );
}
